import { initRefTracker } from "./lib/refTracker";
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from "react-router-dom";
import App from './App.tsx'
import './index.css'
import { takeOverClosedRun } from './lib/tailoringCheckpoint';

// A browser holding a stale index.html after a deploy references hashed JS
// chunks that no longer exist — the import fails and the page goes blank.
// Recover automatically with ONE forced reload (guarded so it can't loop).
window.addEventListener('vite:preloadError', (event) => {
  const KEY = 'chunk-reload-at';
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last > 30_000) {
    sessionStorage.setItem(KEY, String(Date.now()));
    event.preventDefault();
    window.location.reload();
  }
});

initRefTracker();

takeOverClosedRun().finally(() => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>
  );
});
